const brands = ['Chanel', 'Gucci', 'Hermes', 'D&G', 'Dior', 'Versace'];

export default brands;
